import { FETCH_REMOVED_ITEMS } from '../types';

export const removedItemReducers = (state = {}, action) => {
  switch (action.type) {
    case FETCH_REMOVED_ITEMS:
      return { ...state, items: action.payload };
    default:
      return state;
  }
};
